/**
 * Le nom du produit, à un seul endroit.
 *
 * Il s'appelait « Skills Matrix » — le nom des maquettes, resté dans l'en-tête,
 * le pied de page et le titre de l'onglet. Un nom recopié à trois endroits se
 * renomme à deux, d'où cette constante.
 *
 * Le titre de l'onglet, lui, est dans `index.html` : une page statique ne peut
 * pas importer d'ici, et les deux doivent rester d'accord.
 */
export const NOM_PRODUIT = 'Elyadata Engineering';
